var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.999C11 12.5513 11.4477 12.999 12 12.999C12.5523 12.999 13 12.5513 13 11.999C13 11.4467 12.5523 10.999 12 10.999C11.4477 10.999 11 11.4467 11 11.999Z",
    fill: "#0066CC",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.999C18 12.5513 18.4477 12.999 19 12.999C19.5523 12.999 20 12.5513 20 11.999C20 11.4467 19.5523 10.999 19 10.999C18.4477 10.999 18 11.4467 18 11.999Z",
    fill: "#0066CC",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.999C4 12.5513 4.44772 12.999 5 12.999C5.55229 12.999 6 12.5513 6 11.999C6 11.4467 5.55229 10.999 5 10.999C4.44772 10.999 4 11.4467 4 11.999Z",
    fill: "#0066CC",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu.f2ec7f7e9010841588ba2c36dba8cdf1.svg";